
const scrollToFn = {}

scrollToFn.scrollLeft = (element, to, duration) => {
  scrollToFn.scrollTo('Left', element, to, duration)
}

scrollToFn.scrollTop = (element, to, duration) => {
  scrollToFn.scrollTo('Top', element, to, duration)
}

scrollToFn.scrollToElem = (element) => {
  if(typeof element == 'string') element = document.querySelector(selector);
  if(!element) return;
  element.scrollIntoView({
    behavior: 'smooth', 
    block : 'center'
  });
}

scrollToFn.scrollTo = (direction, element, to, duration) => {
  var start = element['scroll'+direction],
    change = to - start,
    currentTime = 0,
    increment = 20;

  var animateScroll = function(){
    currentTime += increment;
    var val = Math.easeInOutQuad(currentTime, start, change, duration);
    element['scroll'+direction] = val;
    if(currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
}

Math.easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
	if (t < 1) return c/2*t*t + b;
	t--;
	return -c/2 * (t*(t-2) - 1) + b;
};

export default scrollToFn;
